import { ReactComponent as RgLogo } from "components/icons/RGLogo.svg";
import { ReactComponent as NounLiveIcon } from "components/icons/nounlive.svg";
import { useCallback } from "react";
import classes from "./AdSearchLink.module.scss";

export const AdSearchLink = () => {
  const handleClick = useCallback(() => {
    // eslint-disable-next-line
    window.location.href = "https://go.xlirdr.com/smartpop/f52326f395fa486598dcfe9ee3c4a8634692e6632ebb459a0474ac53b013fcc2?userId=e71df3d3d26bf187eccc0a7dc93ae2a6d15876511d84af476cb3d0a0b0d0984c&sourceId=SearchBoxLink";
  }, []);

  return (
    <div className={classes.advertSearchLink} onClick={handleClick}>
      <div className={classes.advertSearchIcon}>
        <NounLiveIcon />
      </div>
      <span>Discover more on <RgLogo width="12" height="9"/> Cams</span>
    </div>
  );
};
